export const SourceDashboardRbh = "requestorders/dashboardrbh";
export const TitleDashboardRbh = "Request RBH Dashboard";
export const SourceDashboardPbh = "requestorders/dashboardpbh";
export const TitleDashboardPbh = "Request PBH Dashboard";
export const SourceCmsDashboard = "pbhrequestorders/dashboardcms";
export const TitleCmsDashboard = "CMS Dashboard";
